import { NavigateFunction, NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom';

export interface PoolNavigateFunction extends NavigateFunction {
    (to: number, fallbackUrl?: string): void;
}

export const usePoolNavigate = (fallbackPath?: string): PoolNavigateFunction => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigateInHistory = (delta: number, fallback?: string, options?: NavigateOptions): void => {
        if (location.key === 'default' && fallback) {
            navigate(fallback, options);
        } else {
            navigate(delta);
        }
    };

    const x = (to: To | number, optionsOrFallback: NavigateOptions | string = {}): void => {
        if (typeof to === 'number') {
            const fallback = typeof optionsOrFallback === 'string' ? optionsOrFallback : fallbackPath;
            const options = typeof optionsOrFallback !== 'string' ? optionsOrFallback : {};
            navigateInHistory(to, fallback, options);
        } else {
            const options = typeof optionsOrFallback !== 'string' ? optionsOrFallback : {};
            navigate(to, options);
        }
    };

    return x;
};
